import { useState, useEffect } from "react";
import { T } from "../../config/theme.js";
import { api } from "../../hooks/useApi.js";
import { Btn } from "./index.jsx";

// 얼리버드 폐지 — 하위 호환을 위해 빈 컴포넌트 유지
export function EarlybirdBanner() {
  return null;
}

export function PlanExpiryBanner({ token, plan, goPricing }) {
  const [planInfo, setPlanInfo] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!token || plan === "free") return;
    api("/plan", {}, token).then(data => setPlanInfo(data)).catch(() => {});
  }, [token, plan]);

  if (dismissed || !planInfo || plan === "free") return null;

  // 만료일 체크 (구독 갱신 안내용)
  const expiresAt = planInfo.plan_expires_at ? new Date(planInfo.plan_expires_at) : null;
  if (!expiresAt) return null;

  const now = new Date();
  const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));

  if (daysLeft > 7 || daysLeft < 0) return null;

  const planName = { starter: "Starter", core: "Core", pro: "Pro" }[plan] || plan;

  return (
    <div style={{
      padding: "16px 24px", marginBottom: 16, borderRadius: 14,
      background: `linear-gradient(135deg, ${T.yellow}10, ${T.accent}08)`,
      border: `1px solid ${daysLeft <= 3 ? T.red : T.yellow}30`,
      display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10,
    }}>
      <div>
        <div style={{ fontSize: 14, fontWeight: 800, color: daysLeft <= 3 ? T.red : T.yellow }}>
          {daysLeft <= 3 ? "⚠️" : "📢"} {planName} 구독 {daysLeft}일 남았어요
        </div>
        <div style={{ fontSize: 12, color: T.textDim, marginTop: 4 }}>
          갱신일에 자동 결제돼요. 해지하려면 만료 전에 해주세요.
        </div>
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <Btn variant="ghost" style={{ fontSize: 11, padding: "4px 10px" }} onClick={() => setDismissed(true)}>확인</Btn>
        <Btn variant="ghost" style={{ fontSize: 11, padding: "6px 14px", borderColor: T.accent + "40", color: T.accent }} onClick={goPricing}>플랜 변경</Btn>
      </div>
    </div>
  );
}
